import WebIngestion from "@/components/WebIngestion/WebIngestion";
import { ENABLE_INTERNAL_DEBUGGER } from "@/config/constants";
import DevPage from "@/features/dev/DevPage";
import OpenCanaryTestProject from "@/features/release/components/OpenCanaryTestProject";
import { TaskModal } from "@/features/tasks/TaskModal";
import NotFoundPage from "@/pages/404";
import Authcallback from "@/pages/Authcallback";
import Forbidden from "@/pages/Forbidden";
import LoggedOut from "@/pages/LoggedOut";
import LoginError from "@/pages/LoginError";
import SignInPage from "@/pages/SignIn";
import { Events } from "@/pages/events/Events";
import InternalDebuggerPage from "@/pages/internal-debugger/InternalDebuggerPage";
import { lazy } from "react";
import { Redirect } from "react-router-dom";
import { admin } from "./admin";
import { build } from "./build";
import { monitor } from "./monitor";
import { projects } from "./projects";
import { verify } from "./verify";
const EventIndexHealPage = lazy(() => import("@/pages/internal/EventIndexHealPage"));
const DecisionGraphsShowcase = lazy(() => import("@/features/showcase/decision-graphs"));

const HomeRedirect = () => {
  return <Redirect to={{ pathname: "/projects" }} />;
};

const routes = (
  [
    {
      path: "/",
      component: HomeRedirect,
      layout: "decisively",
      exact: true,
      // This should change in future when the dashboard becomes something that isn't just viewing all projects
      role: ["project-reader", "project-writer", "project-technical"],
    },
    ...projects,
    ...build,
    ...monitor,
    ...verify,
    ...admin,
    {
      path: "/loggedOut",
      component: LoggedOut,
      layout: "centered",
      exact: true,
    },
    {
      path: "/signin",
      component: SignInPage,
      exact: true,
      layout: "centered",
    },
    {
      path: "/authcallback",
      layout: "centered",
      component: Authcallback,
      exact: true,
    },
    {
      path: "/login_error",
      layout: "centered",
      component: LoginError,
      exact: true,
    },
    {
      path: "/forbidden",
      layout: "centered",
      component: Forbidden,
      exact: true,
    },
    {
      path: "/task/:id",
      component: TaskModal,
      layout: "decisively",
      exact: true,
      role: ["project-reader", "project-writer", "project-technical"],
    },
    {
      path: "/events",
      component: () => <Events source="tenancy" />,
      layout: "decisively",
      exact: true,
      role: ["timesheet-admin", "superadmin", "owner"],
    },
  ] as any[]
)
  .concat(
    ENABLE_INTERNAL_DEBUGGER
      ? [
          {
            path: "/internal-debugger",
            component: InternalDebuggerPage,
            layout: "decisively",
            exact: true,
            role: ["superadmin"],
          },
        ]
      : [],
  )
  .concat(
    import.meta && import.meta.env && import.meta.env.DEV
      ? [
          {
            path: "/dev",
            component: DevPage,
            layout: "decisively",
            exact: false,
            role: ["superadmin"],
          },
          {
            // the decision graphs change's before/after measurements (data from scripts/showcase)
            path: "/showcase/decision-graphs",
            component: DecisionGraphsShowcase,
            layout: "decisively",
            exact: true,
            role: ["superadmin"],
          },
          {
            path: "/open",
            component: OpenCanaryTestProject,
            layout: "decisively",
            exact: true,
            role: ["superadmin"],
          },
          {
            path: "/internal/event-index-heal",
            component: EventIndexHealPage,
            layout: "decisively",
            exact: true,
            role: ["superadmin"],
          },
        ]
      : [],
  )
  .concat({
    path: "/:NoMatch",
    component: NotFoundPage,
    layout: "centered",
    exact: false,
  });

export default routes;
